import { render, staticRenderFns } from "./ClientMedPlansVisitServices.vue?vue&type=template&id=df55f966"
import script from "./ClientMedPlansVisitServices.vue?vue&type=script&lang=js"
export * from "./ClientMedPlansVisitServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports